import React, { useEffect, useState } from 'react'
import { superAxiosRequest } from 'axiosApi'
import asideModalStore from 'Stores/asideModalStore'
import swal from 'sweetalert'
import st from './Discounts.module.scss'
import PageHeader from 'components/UI/PageHeader/PageHeader'
import { HeaderAddButton } from 'components/UI/SuperButton/SuperButton'
import Pagination from 'components/UI/Pagination/Pagination'
import Loader from 'components/UI/Loader/Loader'
import RowDiscount from './RowDiscount/RowDiscount'
import AddDiscountModal from './AddDiscountModal/AddDiscountModal'
import useLocalization from 'hooks/useLocalization'

const initPagination = {
  page: 1,
  limit: 10,
}

const Discounts = () => {
  const [discounts, setDiscounts] = useState(null)
  const [loading, setLoading] = useState(false)
  const [pagination, setPagination] = useState(initPagination)

  const { translate } = useLocalization({
    section: 'groups',
    subsection: 'reports',
    dict: {
      add_discount: 'Add discount',
      discount_size: 'Discount size',
      discount: 'Discount',
      discount_type: 'Discount type',
      edit: 'Edit',
      delete: 'Delete',
      entries: 'Entries',
      name: 'Name',
      cancel: 'Cancel',
      save: 'Save',
    },
  })

  const fetchGrades = () => {
    superAxiosRequest({
      method: 'get',
      link: 'groups/discounts',
      params: {
        offset: (pagination.page - 1) * pagination.limit,
        limit: pagination.limit,
      },
    }).then(({ data }) => {
      setDiscounts(data)
      setLoading(false)
    })
  }

  useEffect(() => {
    setLoading(true)
    fetchGrades()
  }, [pagination])

  const onBeforeSubmitClient = (data) => {
    const { name, ...rest } = data
    return {
      ...rest,
      ...(name && { name: data.name }),
    }
  }

  const addGrade = () => {
    const ms = {
      modalBodyComponent: () => <AddDiscountModal translate={translate} />,
      button: translate.save,
      link: 'groups/discounts',
      title: translate.add_discount,
      isResponsive: true,
      onBeforeSubmit: onBeforeSubmitClient,
      onSubmitSuccess: () => {
        fetchGrades()
      },
      valid: {
        name: 'required',
        count: 'required',
        type: 'required',
      },
    }

    asideModalStore.activity(ms, {})
  }

  const editGrade = (data) => {
    const ms = {
      modalBodyComponent: () => <AddDiscountModal translate={translate} />,
      button: translate.save,
      link: `groups/discounts/${data?.id}`,
      title: translate.add_discount,
      isResponsive: true,
      is_put: true,
      onBeforeSubmit: onBeforeSubmitClient,
      onSubmitSuccess: (data) => {
        setDiscounts((prev) => {
          return {
            ...prev,
            result: prev.result.map((age) =>
              age.id === data.id ? { ...age, ...data } : age,
            ),
          }
        })
      },
      valid: {
        name: 'required',
        count: 'required',
        type: 'required',
      },
    }
    asideModalStore.activity(ms, data)
  }

  const deleteGrade = (data) => {
    swal({
      title: 'Are you sure',
      text: 'Are you sure you want to delete the discount?',
      icon: 'warning',
      buttons: ['No', 'Yes'],
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        const apiConf = {
          method: 'delete',
          link: `groups/discounts/${data?.id}`,
        }
        superAxiosRequest(apiConf).then(() => {
          setDiscounts((prevState) => ({
            ...prevState,
            result: prevState.result.filter((el) => el?.id !== data?.id),
          }))
        })
      }
    })
  }

  const action = (action, e, items) => {
    const actions = new Map([
      ['edit', () => editGrade(items)],
      ['delete', () => deleteGrade(items)],
    ])
    return actions.get(action)?.()
  }

  return (
    <div>
      <div className={st.header}>
        <PageHeader title={translate.discount}>
          <HeaderAddButton title={translate.add_discount} onClick={addGrade} />
        </PageHeader>
      </div>
      {loading ? (
        <Loader />
      ) : (
        <div className={st.conteinerClient}>
          <div className={st.quantityClients}>
            {translate.entries}: {discounts?._meta?.count_items}
          </div>
          <div>
            {discounts?.result?.map((discount, index) => (
              <RowDiscount
                key={discount.id}
                discount={discount}
                index={index}
                action={action}
                translate={translate}
              />
            ))}
          </div>
        </div>
      )}
      <div className={st.pagination}>
        {discounts?._meta.count_items > 10 && (
          <Pagination
            limit={pagination.limit}
            count={discounts._meta.count_items || 0}
            page={pagination.page}
            onChange={(page) => setPagination({ ...pagination, page })}
            onChangePerPage={(limit) => {
              setPagination({ page: 1, limit })
            }}
          />
        )}
      </div>
    </div>
  )
}

export default Discounts
